// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// StatClient
export default class StatClient  {
  // id
  public id: number;
  // Email
  public email: string;
  // etablissementId
  public etablissementId: string;
  // refClient
  public refClient: number;
  // Date Creation Compte
  public dateCreationCompte: Date;
  // Abonnement Debut
  public abonnementDebut: Date;
  // Date de première DSN
  public firstDsnDate: Date | null;
  // Abonnement Souscrit
  public abonnementSouscrit: string;
  // Raison Sociale
  public raisonSociale: string;
  // Prenom
  public prenomContact: string;
  // Nom
  public nomContact: string;
  // Siret
  public siret: string;
  // Numero
  public numero: string;
  // hasProject
  public hasProject: boolean;
  // hasContrat
  public hasContrat: boolean;
  // hasSalarie
  public hasSalarie: boolean;
  // hasPaie
  public hasPaie: boolean;
  // Nombre Etablissement
  public nombreEtablissement: number;
  // Commercial
  public commercial: string;
  // CI98
  public ci98: boolean;
  // DOM-TOM
  public isDomtom: boolean;
  // Compte désactivé
  public disabled: boolean;

  constructor() {
    this.id = 0;
    this.email = '';
    this.etablissementId = '';
    this.refClient = 0;
    this.dateCreationCompte = new Date(1901,1,1,0,0,0,0);
    this.abonnementDebut = new Date(1901,1,1,0,0,0,0);
    this.firstDsnDate = null;
    this.abonnementSouscrit = '';
    this.raisonSociale = '';
    this.prenomContact = '';
    this.nomContact = '';
    this.siret = '';
    this.numero = '';
    this.hasProject = false;
    this.hasContrat = false;
    this.hasSalarie = false;
    this.hasPaie = false;
    this.nombreEtablissement = 0;
    this.commercial = '';
    this.ci98 = false;
    this.isDomtom = false;
    this.disabled = false;
  }

  public static fromJson (obj: StatClient): StatClient {
    const newStatClient: StatClient = new StatClient();
    newStatClient.id = obj.id;
    newStatClient.email = obj.email;
    newStatClient.etablissementId = obj.etablissementId;
    newStatClient.refClient = obj.refClient;
    newStatClient.dateCreationCompte = new Date(obj.dateCreationCompte);
    newStatClient.abonnementDebut = new Date(obj.abonnementDebut);
    newStatClient.firstDsnDate = obj.firstDsnDate ? new Date(obj.firstDsnDate) : null;
    newStatClient.abonnementSouscrit = obj.abonnementSouscrit;
    newStatClient.raisonSociale = obj.raisonSociale;
    newStatClient.prenomContact = obj.prenomContact;
    newStatClient.nomContact = obj.nomContact;
    newStatClient.siret = obj.siret;
    newStatClient.numero = obj.numero;
    newStatClient.hasProject = obj.hasProject;
    newStatClient.hasContrat = obj.hasContrat;
    newStatClient.hasSalarie = obj.hasSalarie;
    newStatClient.hasPaie = obj.hasPaie;
    newStatClient.nombreEtablissement = obj.nombreEtablissement;
    newStatClient.commercial = obj.commercial;
    newStatClient.ci98 = obj.ci98;
    newStatClient.isDomtom = obj.isDomtom;
    newStatClient.disabled = obj.disabled;
    return newStatClient;
  }

  public toJsonStatClient (): string {
    const json = {
      id: this.id,
      email: this.email,
      etablissementId: this.etablissementId,
      refClient: this.refClient,
      dateCreationCompte: this.dateCreationCompte ? new Date (this.dateCreationCompte).toString() : this.dateCreationCompte,
      abonnementDebut: this.abonnementDebut ? new Date (this.abonnementDebut).toString() : this.abonnementDebut,
      firstDsnDate: this.firstDsnDate ? new Date (this.firstDsnDate).toString() : this.firstDsnDate,
      abonnementSouscrit: this.abonnementSouscrit,
      raisonSociale: this.raisonSociale,
      prenomContact: this.prenomContact,
      nomContact: this.nomContact,
      siret: this.siret,
      numero: this.numero,
      hasProject: this.hasProject,
      hasContrat: this.hasContrat,
      hasSalarie: this.hasSalarie,
      hasPaie: this.hasPaie,
      nombreEtablissement: this.nombreEtablissement,
      commercial: this.commercial,
      ci98: this.ci98,
      isDomtom: this.isDomtom,
      disabled: this.disabled,
    }
    return JSON.stringify(json);
  }

  public fromStatClient (obj: StatClient): void {
    this.id = obj.id;
    this.email = obj.email;
    this.etablissementId = obj.etablissementId;
    this.refClient = obj.refClient;
    this.dateCreationCompte = new Date(obj.dateCreationCompte);
    this.abonnementDebut = new Date(obj.abonnementDebut);
    this.firstDsnDate = obj.firstDsnDate;
    this.abonnementSouscrit = obj.abonnementSouscrit;
    this.raisonSociale = obj.raisonSociale;
    this.prenomContact = obj.prenomContact;
    this.nomContact = obj.nomContact;
    this.siret = obj.siret;
    this.numero = obj.numero;
    this.hasProject = obj.hasProject;
    this.hasContrat = obj.hasContrat;
    this.hasSalarie = obj.hasSalarie;
    this.hasPaie = obj.hasPaie;
    this.nombreEtablissement = obj.nombreEtablissement;
    this.commercial = obj.commercial;
    this.ci98 = obj.ci98;
    this.isDomtom = obj.isDomtom;
    this.disabled = obj.disabled;
  }

  public compareStatClient (value: StatClient): boolean {
    return (this.toJsonStatClient() == value.toJsonStatClient());
  }

  public cloneStatClient (): StatClient {
    return StatClient.fromJson(this);
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/statclients/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(statClients: StatClient[]) {
    statClients.forEach((item) => {
      item.dateCreationCompte = item.dateCreationCompte ? new Date(item.dateCreationCompte) : item.dateCreationCompte;
      item.abonnementDebut = item.abonnementDebut ? new Date(item.abonnementDebut) : item.abonnementDebut;
      item.firstDsnDate = item.firstDsnDate ? new Date(item.firstDsnDate) : item.firstDsnDate;
    })
  }
}
